import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-error-dialog',
  imports: [ButtonModule, DialogModule, TranslateModule],
  templateUrl: 'error-dialog.component.html',
  styleUrl: 'error-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorDialogComponent {
  @Input({ required: true }) message = ''

  private readonly dynamicDialogRef = inject(DynamicDialogRef)

  onClose() {
    this.dynamicDialogRef.close()
  }
}
